import React from 'react';
import styled from 'styled-components';
import { Box } from 'src/kit/Box';
import { Flex } from 'src/kit/Flex';
import logo1 from 'images/update_landing/universities/Bocconi University.svg';
import logo2 from 'images/update_landing/universities/cambridge_university2.svg';
import logo3 from 'images/update_landing/universities/CentraleSupélec.png';
import logo4 from 'images/update_landing/universities/Ecole_Polytechnique.png';
import logo5 from 'images/update_landing/universities/EDHEC.jpeg';
import logo6 from 'images/update_landing/universities/emlyon.jpeg';
import logo7 from 'images/update_landing/universities/ESCP.png';
import logo8 from 'images/update_landing/universities/ESSEC.png';
import logo9 from 'images/update_landing/universities/HEC.png';
import logo10 from 'images/update_landing/universities/Imperial College London.svg';
import logo11 from 'images/update_landing/universities/LSE_logo.svg';
import logo12 from 'images/update_landing/universities/MINES.png';
import logo13 from 'images/update_landing/universities/ParisTech.png';
import logo14 from 'images/update_landing/universities/University of St. Gallen.svg';
import logo15 from 'images/update_landing/universities/University_of_Warwick.svg';
import logo16 from 'images/update_landing/universities/oxweb-logo.svg';

const SchoolLogoCell = styled.div<{ scale?: number }>`
  background: #fdfefe;
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8ecf0;
  transition: all 0.3s ease;
  height: 140px;

  &:hover {
    border-color: rgba(45, 189, 150, 0.4);
    box-shadow: 0 12px 32px rgba(13, 27, 42, 0.08);
    transform: translateY(-4px);
    background: #ffffff;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: grayscale(100%);
    opacity: 0.6;
    transition: all 0.4s ease;
    transform: scale(${(props) => props.scale || 1});
  }

  &:hover img {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(${(props) => (props.scale || 1) * 1.08});
  }
`;

const EmployerSchools = () => {
  const schools = [
    { id: 9, src: logo9, name: 'HEC Paris', height: 180, scale: 1.5 },
    { id: 8, src: logo8, name: 'ESSEC Business School', height: 70 },
    { id: 7, src: logo7, name: 'ESCP Business School', height: 70 },
    { id: 5, src: logo5, name: 'EDHEC Business School', height: 80, scale: 1.4 },
    { id: 6, src: logo6, name: 'emlyon business school', height: 90, scale: 1.4 },
    { id: 4, src: logo4, name: 'École Polytechnique', height: 140, scale: 1.4 },
    { id: 12, src: logo12, name: 'Mines Paris - PSL', height: 120 },
    { id: 3, src: logo3, name: 'CentraleSupélec', height: 80, scale: 1.6 },
    { id: 13, src: logo13, name: 'Ponts ParisTech', height: 80, scale: 1.5 },
    { id: 11, src: logo11, name: 'London School of Economics and Political Science', height: 50 },
    { id: 16, src: logo16, name: 'University of Oxford', height: 70, scale: 2 },
    { id: 2, src: logo2, name: 'University of Cambridge', height: 50 },
    { id: 10, src: logo10, name: 'Imperial College London', height: 50 },
    { id: 1, src: logo1, name: 'Bocconi University', height: 160, scale: 1.4 },
    { id: 15, src: logo15, name: 'University of Warwick', height: 50 },
    { id: 14, src: logo14, name: 'University of St. Gallen', height: 70 },
  ];

  return (
    <Box
      as="section"
      id="schools"
      style={{ background: '#ffffff', padding: '100px 5%', borderTop: '1px solid #e8ecf0' }}
    >
      <Box style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Flex
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: '40px',
            marginBottom: '64px',
            flexWrap: 'wrap',
          }}
        >
          <Box>
            <Flex style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <Box style={{ width: '24px', height: '2px', background: '#2dbd96' }} />
              <Box
                style={{
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#2dbd96',
                }}
              >
                Target Universities
              </Box>
            </Flex>
            <Box
              as="h2"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
                fontWeight: 700,
                color: '#1a2332',
                maxWidth: '600px',
                lineHeight: 1.1,
              }}
            >
              Access the best talent from top European universities.
            </Box>
          </Box>

          <Box style={{ textAlign: 'right' }}>
            <Box
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '4.5rem',
                fontWeight: 900,
                color: '#2dbd96',
                lineHeight: 1,
              }}
            >
              60+
            </Box>
            <Box style={{ fontSize: '0.95rem', color: '#8a99a8', marginTop: '8px', fontWeight: 500 }}>
              European partner schools
            </Box>
          </Box>
        </Flex>

        <Box
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '24px',
          }}
          css={`
            @media (max-width: 1024px) {
              grid-template-columns: repeat(3, 1fr) !important;
              gap: 20px !important;
            }
            @media (max-width: 768px) {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 16px !important;
            }
            @media (max-width: 480px) {
              grid-template-columns: repeat(1, 1fr) !important;
            }
          `}
        >
          {schools.map((school) => (
            <SchoolLogoCell key={school.id} scale={school.scale}>
              <img
                src={school.src}
                alt={school.name}
                style={{
                  height: school.height,
                  maxHeight: '100%',
                  maxWidth: '100%',
                }}
              />
            </SchoolLogoCell>
          ))}
        </Box>
        <Box
          style={{
            marginTop: '32px',
            textAlign: 'center',
            fontSize: '1rem',
            color: '#8a99a8',
            fontStyle: 'italic',
          }}
        >
          + many more across UK, France, DACH, and Iberia.
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerSchools;
